<template>
  <div
    class="right-item cursor"
    :class="{ visible: isVisible }"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    @click="navigateToLink"
  >
    <div class="content">
      <video autoplay loop muted playsinline class="main-image">
        <source src="/static_img/skinc/materiality/sk_motion_1.mp4" type="video/mp4" />
        {{
          lang === 'ENG'
            ? 'Your browser does not support the video tag.'
            : '브라우저가 비디오 태그를 지원하지 않습니다.'
        }}
      </video>

      <div class="badge-section w-100">
        <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span class="skinc-badge">Step 1</span>
          <h3 v-if="lang !== 'ENG'" class="step-title">이해관계자 참여</h3>
          <h3 v-else class="step-title en-font">Stakeholder Engagement</h3>
        </div>

        <div class="more-section">
          <button class="view-button">
            <img
              v-if="isHovered"
              src="/static_img/skinc/appendix/arrow_focus.svg"
              class="arrow-icon"
              alt="arrow"
            />
            <img
              v-else
              src="/static_img/skinc/appendix/arrow_normal.svg"
              class="arrow-icon"
              alt="arrow"
            />
          </button>
        </div>
      </div>

      <p v-if="lang !== 'ENG'" class="description">
        핵심 이해관계자를 식별하고 비즈니스와 연관된 이해관계자의 요구사항을 경영 활동에 반영하고
        있습니다.
      </p>
      <p v-else class="description en-font">
        Key stakeholders are identified, and the expectations of those relevant to the business are
        reflected in management practices.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Process1',
  props: {
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isHovered: false,
      isVisible: false,
      observer: null
    };
  },
  computed: {
    ...mapState('report_list', ['lang'])
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      {
        threshold: 0.2
      }
    );
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    navigateToLink() {
      if (this.link) {
        let finalLink = this.link;
        if (this.lang === 'ENG') {
          if (finalLink.includes('?')) {
            finalLink += '&l=ENG';
          } else {
            finalLink += '?l=ENG';
          }
        }
        window.location.href = finalLink;
      }
    }
  }
};
</script>

<style>
.right-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: clamp(1.5rem, 3vw, 2.5rem);
  box-sizing: border-box;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 16px;
  background-color: white;
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease, transform 0.8s ease, box-shadow 0.3s ease;
}

.right-item.visible {
  opacity: 1;
  transform: translateY(0);
}

.right-item:hover {
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.main-image {
  width: 100%;
  max-width: 150px;
}

@media (max-width: 992px) {
  .main-image {
    width: 100%;
    max-width: 100px;
  }
}

.main-image::-webkit-media-controls {
  display: none !important;
}

.main-image::-webkit-media-controls-enclosure {
  display: none !important;
}

.badge-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
}

.skinc-badge {
  background-color: #ea002cff;
  color: white;
  padding: 6px 12px;
  border-radius: 18px;
  font-size: clamp(12px, 2vw, 16px);
  margin-bottom: 8px;
  margin-right: 16px;
}

.step-title {
  font-weight: bold;
  text-align: center;
  color: #000;
  font-size: clamp(24px, 3vw, 40px);
}

.description {
  color: #4b4b4b;
  text-align: left;
  line-height: 1.5;
  margin-bottom: 20px;
  font-size: clamp(18px, 2.5vw, 24px);
}

.step-title.en-font {
  font-size: clamp(19.2px, 2.4vw, 32px);
}

.description.en-font {
  font-size: clamp(14.4px, 2vw, 19.2px);
}

.more-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-left: auto;
}

.view-button {
  background: none;
  border: none;
  cursor: pointer;
}

.arrow-icon {
  width: 40px;
  height: 40px;
}

.divider {
  width: 100%;
  border: 1px solid #ccc;
  margin: 20px 0;
}

.bottom-image {
  width: 80%;
  max-width: 200px;
}
</style>
